angular.module('harriApp')
    .directive('eVerifyHeader', ["$state", function ($state) {
        return {
            restrict: "E",
            replace: true,
            scope: {
                'brandId': '@?',
            },
            templateUrl: '../modules/training/e-verify/views/directives/e_verify_header_directive.html',
            link: function (scope, element) {

                scope.isActive = function (state) {
                    return $state.current.name === state;
                }

            }
        }
    } ]);
